import '.ew{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ex{padding-left:1.5rem;}.ssr-plugin'
import '.ey{margin:1rem 0;}.ssr-plugin'
import '.ez{color:var(--gray-700);}.ssr-plugin'
import '.f0{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ew ex ey ez f0"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
